/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { FaTimes } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';

import { logEvent } from '../../utils/logEvent';
import StyledTappable from '../../components/common/StyledTappable';
import LoadingComponent from '../../components/common/LoadingComponent';
import FooterButton from '../../components/common/FooterButton';
import { PrimaryButton } from '../../components/common/Buttons';
import PatientModal from '../../components/common/PatientModal';
import Modal from '../../containers/common/Modal';
import {
  fetchProfile,
  fetchAssistantProfile,
  defaultIssueSearch,
  fetchSlots,
  getAllDopeRelatives,
} from '../../services';
import { SERVICE_LINE_NAMES } from '../../config';
import CalendarModal from '../../components/consultations/CalendarModal';
import { FlyInTransition } from '../../components/transitions/transitions';
import clientConfig from '../../clientConfig';

import arrowBack from '../../images/arrow_back.svg';
import medal from '../../images/medal.svg';
import profileHospital from '../../images/consultations/new-flow/profile/profile-hospital.svg';
import megaPhone from '../../images/megaphone.svg';
import education from '../../images/education.svg';
import hospitalLogo from '../../images/consultations/new-flow/hospital-building.png';
import doctorPlaceHolder from '../../images/consultations/doctor-placeholder.svg';
import slotIcon from '../../images/lab-test/slot.svg';
import morningIcon from '../../images/lab-test/morning.svg';
import afternoonIcon from '../../images/lab-test/afternoon.svg';
import eveningIcon from '../../images/lab-test/evening.svg';
import slotSelected from '../../images/lab-test/tick.svg';

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 16px 0;
  padding-left: 16px;
  z-index: 9;
  background: #fff;
  width: 100%;
  border-bottom: 1px solid #f0f3f6;
  z-index: 0;
  border-radius: 12px 12px 0 0;
`;

const SecondaryContainer = styled.div`
  display: flex;
  padding: 14px;
`;
const HeaderText = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  color: #0f0b28;
  /* margin-left: 4px; */
`;

const ContainerWithBorder = styled.div`
  background: #ffffff;
  border: 1px solid #e3e3e3;
  width: calc(100%-40px);
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  margin: 16px;
  margin-bottom: 0;
`;
const Row = styled.div`
  display: flex;
  padding-left: 20px;
  flex-direction: row;
  margin-top: 16px;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 12px;
`;

const DoctorImage = styled.img`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  src: url(${(props) => props.src});
  object-fit: cover;
`;
const DoctorName = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 140%;
  color: #0f0b28;
`;

const Profession = styled.div`
  font-weight: 500;
  font-size: 10px;
  line-height: 150%;
  margin-top: 2px;
  color: #585969;
  margin-right: 16px;
  word-break: initial;
`;

const LanguageText = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #585969;
  margin-left: 4px;
  max-width: 90%;
`;

const SecondaryTitleText = styled.div`
  font-weight: 600;
  font-size: 14px;
  margin-left: 8px;
  color: #0f0b28;
`;

const BodyText = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #0f0b28;
  margin: 8px 4px 2px 2px;
`;

const QualificationBodyText = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #0f0b28;
  margin: 11px 4px 2px 2px;
  text-wrap: pretty;
`;

const CloseContainer = styled(StyledTappable)`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = styled(FaTimes)`
  color: #413958;
`;
const DoctorProfileNew = (props) => {
  const {
    doctorId,
    assistantDoctor,
    closeProfile,
    footer,
    labOrderId,
    relativeId,
  } = props;
  const authToken = useSelector((state) => state.user.authToken);
  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(false);
  const [doctorProfile, setDoctorProfile] = useState({});
  const [doctorSlots, setDoctorSlots] = useState(null);

  const [disclaimersAndCheckboxes, setDisclaimerAndCheckboxes] = useState([]);
  const [disclaimerMessage, setDisclaimerMessage] = useState('');
  const [activeSlotType, setActiveSlotType] = useState(1);
  const [slots, setSlots] = useState([]);
  const [morningSlot, setMorningSlots] = useState([]);
  const [afternoonSlot, setAfternoonSlots] = useState([]);
  const [eveningSlot, setEveningSlots] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showSlots, setShowSlots] = useState(false);
  const [patientModal, setPatientModal] = useState(false);
  const [appointmentDetails, setAppointmentDetails] = useState({
    date: '',
    time: '',
  });
  const [selectedRelative, setSelectedRelative] = useState({
    relativeId: -1,
    relativeRelation: null,
    relativeIcon: null,
  });

  useEffect(() => {
    logEvent('Online Consultations Doctor Profile Screen');
    getDefaultIssues();
    if (assistantDoctor) {
      getAssistantProfile();
    } else {
      getProfile();
    }
  }, []);

  useEffect(() => {
    // bookDoctor function controls logic for relative, date, time selection as and when required for active inactive doctor
    if (selectedRelative.relativeId !== -1) {
      bookDoctorFunc();
    }
  }, [selectedRelative]);

  useEffect(() => {
    // Filter slots after date selection state change
    if (!appointmentDetails.date) return;
    slots
      .filter((s) => {
        return s.date === appointmentDetails.date;
      })
      .map((t) => {
        if (t.slots) {
          let m = [];
          let a = [];
          let e = [];

          m = t.slots.filter((slot) => Number(slot.substring(0, 2)) < 12);
          a = t.slots.filter(
            (slot) =>
              Number(slot.substring(0, 2)) >= 12 &&
              Number(slot.substring(0, 2)) <= 16
          );
          e = t.slots.filter((slot) => Number(slot.substring(0, 2)) > 16);
          setMorningSlots(m);
          setAfternoonSlots(a);
          setEveningSlots(e);

          if (morningSlot.length > 0) setActiveSlotType(1);
          else if (afternoonSlot.length > 0) setActiveSlotType(2);
          else if (eveningSlot.length > 0) setActiveSlotType(3);
        }
      });
  }, [appointmentDetails.date]);

  const getAssistantProfile = () => {
    fetchAssistantProfile(doctorId, authToken)
      .then((res) => {
        setDoctorProfile(res.result[0]);

        setLoading(false);
      })
      .catch((err) => {
        console.error('Error in fetching assistant profile ', err);
      });
  };

  const getProfile = () => {
    const { doctorId, currentLat, currentLong } = props;
    let lat = currentLat !== -1 ? currentLat : undefined;
    let lng = currentLong !== -1 ? currentLong : undefined;
    fetchProfile(doctorId, lat, lng, authToken, relativeId)
      .then((res) => {
        setDoctorProfile(res.result[0]);
        setActive(res.isActive);
        setDoctorSlots(res.doctorRoster);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error in fetching profile ', err);
      });
  };

  const onDateSelection = (date) => {
    setAppointmentDetails((prev) => ({
      ...prev,
      date: date
        .toLocaleDateString('fr-CA', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
        .toString(),
    }));
    setShowCalendar(false);
    setShowSlots(true);
  };

  const renderSlots = (ele, last) => {
    return (
      <div
        className="border-b border-solid border-txtsecondary-shades7 px-3 py-3"
        style={
          last
            ? {
                display: 'grid',
                gridTemplateColumns: '1fr 5fr',
                borderBottom: 'none',
              }
            : { display: 'grid', gridTemplateColumns: '1fr 5fr' }
        }
      >
        <div className="text-caption-s text-primary-button font-bold  mr-2 border-r border-txtsecondary-shades7 flex items-center">
          {ele.day.substr(0, 3)}
        </div>
        <div className="flex">
          {ele.roster.map((slot) => (
            <div className="px-3 py-5px border border-txtlight-shades4 rounded-8 mr-2 bg-txtlight-shades4">
              <p className="text-chip font-semibold text-txtlight">
                {slot.startHour < 12
                  ? slot.startHour
                  : slot.startHour % 12 === 0
                    ? '12'
                    : slot.startHour % 12}{' '}
                <sup>
                  {slot.startHour <= 12 || slot.startHour === '24'
                    ? 'AM'
                    : 'PM'}
                </sup>{' '}
                -{' '}
                {slot.endHour < 12
                  ? slot.endHour
                  : slot.endHour % 12 === 0
                    ? '12'
                    : slot.endHour % 12}{' '}
                <sup>
                  {slot.endHour <= 12 || slot.endHour === '24' ? 'AM' : 'PM'}
                </sup>
              </p>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const SLOTS_TAB = [
    { label: 'Morning', value: 1, icon: morningIcon, slots: morningSlot },
    {
      label: 'Afternoon',
      value: 2,
      icon: afternoonIcon,
      slots: afternoonSlot,
    },
    { label: 'Evening', value: 3, icon: eveningIcon, slots: eveningSlot },
  ];

  const selectRelative = (relative) => {
    logEvent('Online Consultation Patient Selected', {
      patientId: relative.relativeId,
      patientName: relative.relativeName,
    });

    setSelectedRelative(relative);
    setPatientModal(false);
  };

  const bookDoctorFunc = () => {
    logEvent('Online Consultations Consult Button');

    if (selectedRelative.relativeId === -1) {
      setPatientModal(true);
      return;
    }

    const bookDoctor = doctorProfile;
    const consultType = active ? 'bn' : 'bfl';

    const consultRequestInfo = {
      relative: selectedRelative,
    };
    fetchSlotsFunc(bookDoctor, consultRequestInfo, consultType);
  };

  const fetchSlotsFunc = async (doctor, consultRequestInfo, consultType) => {
    let gcds = true; // default true

    if (doctor?.nextRosterTimestamp) {
      const nextRosterTimestamp = doctor?.nextRosterTimestamp;
      const doctorAvailabilityDate = new Date(nextRosterTimestamp * 1000);

      let now = new Date();
      let tomorrowsDate = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1
      );
      // if doctor is available before tomorrow, get current day slots else not
      gcds = doctorAvailabilityDate < tomorrowsDate;
    }
    if (
      active ||
      (!active && appointmentDetails.date && appointmentDetails.time)
    ) {
      history.push('/consultation/confirm', {
        doctor: doctor,
        consultRequestInfo: consultRequestInfo,
        assistantBooking: doctor.isAssistant,
        type: consultType,
        slots,
        labOrderId,
        appointmentDetails,
      });
    } else {
      try {
        const res = await fetchSlots(doctor.doctorId, authToken, gcds);
        setSlots(res.data);
        setShowCalendar(true);
      } catch (err) {
        console.error('Error in fetching slot details ', err);
      }
    }
  };

  const getDefaultIssues = async () => {
    // Disclaimer to show in Patient Modal in tele consult comes from prereqs api
    try {
      const resp = await defaultIssueSearch('treat', authToken);
      const { disclaimersAndCheckboxes, disclaimerMessage } = resp;
      setDisclaimerAndCheckboxes(disclaimersAndCheckboxes);
      setDisclaimerMessage(disclaimerMessage);
    } catch (err) {
      console.error(err);
    }
  };

  const {
    profileImg,
    doctorName,
    vertical,
    experience,
    orgName,
    summary,
    qualification,
    specializations,
    baseFee,
    finalFee,
    knownLanguages,
  } = doctorProfile;

  let bookingLabelText = '';
  if (active) {
    bookingLabelText = 'Consult Now';
  } else if (!active) {
    bookingLabelText = 'Book for later';
  }

  const SlotsTabs = (props) => (
    // render Morning, Afternoon, Evening tabs
    <div className="flex flex-row items-center  bg-primary-light rounded-8 p-2">
      {SLOTS_TAB.map((t, index) => {
        if (t.slots.length === 0) return null;
        return (
          <div
            className={`flex flex-row items-center cursor-pointer ${
              activeSlotType === t.value && 'bg-textbox'
            }  rounded-8 px-4 py-2`}
            onClick={(e) => {
              e.stopPropagation();
              setActiveSlotType(t.value);
            }}
          >
            <img src={t.icon} alt="morning" />
            <p className="ml-4px text-body-s text-txtlight font-medium">
              {t.label}
            </p>
          </div>
        );
      })}
    </div>
  );

  const ShowSlotSection = ({ slots, value }) => {
    if (value !== activeSlotType) return null;

    if (slots.length === 0)
      return (
        <div className="flex flex-row items-center h-12 justify-center">
          <p className="ml-4px text-body-s text-txtlight font-medium">
            No Slots Available
          </p>
        </div>
      );

    return (
      <div className="flex-row-wrap">
        {slots.map((s, index) => {
          return (
            <div
              className={`slot-time ${
                appointmentDetails.time === s
                  ? 'selected-slot-time'
                  : 'unselected-slot-time'
              } flex flex-row items-center justify-center cursor-pointer`}
              style={{
                width: '90px',
                height: '32px',
              }}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                setAppointmentDetails((prev) => ({
                  ...prev,
                  time: s,
                }));
              }}
            >
              {appointmentDetails.time !== s ? (
                <span className="txt-600-12">{s}</span>
              ) : (
                <div className="flex flex-row items-center justify-center">
                  <img src={slotSelected} alt="" />
                  <span className="ml-8px txt-600-12">{s}</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div
      className="flex flex-col h-full relative items-stretch doctorProfileModal "
      onClick={(e) => e.stopPropagation()}
    >
      <Header className="doctorProfileHeader">
        <button onClick={closeProfile}>
          <img src={arrowBack} alt="arrow-back" />
        </button>
        <HeaderText>Profile</HeaderText>
      </Header>
      {loading ? (
        <div style={{ height: '100svh', background: '#ffffff' }}>
          <LoadingComponent />
        </div>
      ) : (
        <>
          <div className="flex-col overflow-auto pb-100px">
            <ContainerWithBorder className="pt-4 pb-2">
              <div className="flex px-4">
                <DoctorImage src={profileImg ?? doctorPlaceHolder} />
                <Column>
                  <DoctorName>{doctorName}</DoctorName>
                  <Profession>{vertical}</Profession>
                  <Profession>{experience}</Profession>
                </Column>
              </div>
              <div className="px-4 mt-4">
                {orgName && (
                  <div className="flex border-t border-txtsecondary-shades7 mt-4">
                    <div className="flex py-2 gap-2">
                      <div className="w-5">
                        <img src={profileHospital} alt="hospital-logo" />
                      </div>
                      <LanguageText>{orgName}</LanguageText>
                    </div>
                  </div>
                )}
                {qualification?.length !== 0 && (
                  <div className="flex border-t border-txtsecondary-shades7 mt-4">
                    <div className="flex py-2 gap-2">
                      <div className="w-5">
                        <img src={education} alt="edu" />
                      </div>
                      <LanguageText>{qualification.join(', ')}</LanguageText>
                    </div>
                  </div>
                )}
                {knownLanguages && (
                  <div className="flex border-t border-txtsecondary-shades7 mt-4">
                    <div className="flex py-2 gap-2">
                      <div className="w-5">
                        <img src={megaPhone} alt="megaphone" />
                      </div>
                      <LanguageText>{knownLanguages}</LanguageText>
                    </div>
                  </div>
                )}
              </div>
            </ContainerWithBorder>
            <ContainerWithBorder>
              <SecondaryContainer>
                <div className="flex justify-between flex-1 ">
                  <div className="flex items-center flex-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="24"
                        height="24"
                        rx="12"
                        fill="#244CB2"
                        fill-opacity="0.1"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M5.33301 10.6665C5.33301 11.0347 5.63148 11.3332 5.99967 11.3332H6.66634C8.50729 11.3332 9.99967 9.84079 9.99967 7.99984V7.33317C9.99967 6.96498 9.7012 6.6665 9.33301 6.6665C8.96482 6.6665 8.66634 6.96498 8.66634 7.33317V7.99984C8.66634 9.10441 7.77091 9.99984 6.66634 9.99984H5.99967C5.63148 9.99984 5.33301 10.2983 5.33301 10.6665ZM13.333 11.9998C13.333 12.7362 12.7361 13.3332 11.9997 13.3332C11.2633 13.3332 10.6663 12.7362 10.6663 11.9998C10.6663 11.2635 11.2633 10.6665 11.9997 10.6665C12.7361 10.6665 13.333 11.2635 13.333 11.9998ZM5.33301 13.3332C5.33301 12.965 5.63148 12.6665 5.99967 12.6665H6.66634C8.50729 12.6665 9.99967 14.1589 9.99967 15.9998V16.6665C9.99967 17.0347 9.7012 17.3332 9.33301 17.3332C8.96482 17.3332 8.66634 17.0347 8.66634 16.6665V15.9998C8.66634 14.8953 7.77091 13.9998 6.66634 13.9998H5.99967C5.63148 13.9998 5.33301 13.7014 5.33301 13.3332ZM17.9997 12.6665C18.3679 12.6665 18.6663 12.965 18.6663 13.3332C18.6663 13.7014 18.3679 13.9998 17.9997 13.9998H17.333C16.2284 13.9998 15.333 14.8953 15.333 15.9998V16.6665C15.333 17.0347 15.0345 17.3332 14.6663 17.3332C14.2982 17.3332 13.9997 17.0347 13.9997 16.6665V15.9998C13.9997 14.1589 15.4921 12.6665 17.333 12.6665H17.9997ZM17.9997 11.3332C18.3679 11.3332 18.6663 11.0347 18.6663 10.6665C18.6663 10.2983 18.3679 9.99984 17.9997 9.99984H17.333C16.2284 9.99984 15.333 9.10441 15.333 7.99984V7.33317C15.333 6.96498 15.0345 6.6665 14.6663 6.6665C14.2982 6.6665 13.9997 6.96498 13.9997 7.33317V7.99984C13.9997 9.84079 15.4921 11.3332 17.333 11.3332H17.9997Z"
                        fill="#244CB2"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.17214 6.6665H14.8272C15.3639 6.6665 15.8068 6.66649 16.1676 6.69597C16.5423 6.72658 16.8868 6.79229 17.2103 6.95715C17.7121 7.21282 18.12 7.62076 18.3757 8.12253C18.5406 8.44609 18.6063 8.79056 18.6369 9.16529C18.6664 9.52608 18.6664 9.96898 18.6663 10.5056V13.4941C18.6664 14.0307 18.6664 14.4736 18.6369 14.8344C18.6063 15.2091 18.5406 15.5536 18.3757 15.8771C18.12 16.3789 17.7121 16.7869 17.2103 17.0425C16.8868 17.2074 16.5423 17.2731 16.1676 17.3037C15.8068 17.3332 15.3638 17.3332 14.8272 17.3332H9.17216C8.6355 17.3332 8.19259 17.3332 7.83179 17.3037C7.45706 17.2731 7.11259 17.2074 6.78903 17.0425C6.28727 16.7869 5.87932 16.3789 5.62366 15.8771C5.4588 15.5536 5.39309 15.2091 5.36247 14.8344C5.33299 14.4736 5.333 14.0307 5.33301 13.494V10.5056C5.333 9.96899 5.33299 9.52608 5.36247 9.16529C5.39309 8.79056 5.4588 8.44609 5.62366 8.12253C5.87932 7.62076 6.28727 7.21282 6.78903 6.95715C7.11259 6.79229 7.45706 6.72658 7.83179 6.69597C8.19259 6.66649 8.6355 6.6665 9.17214 6.6665ZM7.94037 8.02487C7.64809 8.04875 7.49862 8.09204 7.39435 8.14516C7.14347 8.27299 6.9395 8.47697 6.81167 8.72785C6.75854 8.83212 6.71526 8.98159 6.69138 9.27386C6.66686 9.57392 6.66634 9.96212 6.66634 10.5332V13.4665C6.66634 14.0376 6.66686 14.4258 6.69138 14.7258C6.71526 15.0181 6.75854 15.1676 6.81167 15.2718C6.9395 15.5227 7.14347 15.7267 7.39435 15.8545C7.49862 15.9076 7.64809 15.9509 7.94037 15.9748C8.24043 15.9993 8.62862 15.9998 9.19968 15.9998H14.7997C15.3707 15.9998 15.7589 15.9993 16.059 15.9748C16.3513 15.9509 16.5007 15.9076 16.605 15.8545C16.8559 15.7267 17.0599 15.5227 17.1877 15.2718C17.2408 15.1676 17.2841 15.0181 17.308 14.7258C17.3325 14.4258 17.333 14.0376 17.333 13.4665V10.5332C17.333 9.96212 17.3325 9.57392 17.308 9.27386C17.2841 8.98159 17.2408 8.83212 17.1877 8.72785C17.0599 8.47697 16.8559 8.27299 16.605 8.14516C16.5007 8.09204 16.3513 8.04875 16.059 8.02487C15.7589 8.00036 15.3707 7.99984 14.7997 7.99984H9.19968C8.62862 7.99984 8.24043 8.00036 7.94037 8.02487Z"
                        fill="#244CB2"
                      />
                    </svg>
                    <SecondaryTitleText>You Pay</SecondaryTitleText>
                  </div>
                  <div className="flex flex-1 items-center justify-end">
                    {baseFee !== finalFee && (
                      <div
                        className="txt-grey-500-12 mr-5"
                        style={{ textDecoration: 'line-through' }}
                      >
                        ₹{baseFee}
                      </div>
                    )}
                    <SecondaryTitleText>₹{finalFee}</SecondaryTitleText>
                  </div>
                </div>
              </SecondaryContainer>
            </ContainerWithBorder>
            {doctorSlots && doctorSlots.length > 0 && (
              <>
                <p className="text-body-s font-bold text-txtlight mx-20px mt-20px">
                  Available Slots for Booking Upcoming Appointments
                </p>
                <ContainerWithBorder>
                  {doctorSlots.map((ele, idx, arr) =>
                    renderSlots(ele, idx === arr.length - 1)
                  )}
                </ContainerWithBorder>
              </>
            )}
            {summary && (
              <ContainerWithBorder>
                <SecondaryContainer>
                  <div className="flex flex-col p-2px">
                    <div className="flex flex-row items-center">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="12" cy="12" r="12" fill="#F5F4FF" />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M10.0003 14.6668C8.89576 14.6668 8.00033 15.5623 8.00033 16.6668C8.00033 17.035 8.2988 17.3335 8.66699 17.3335H15.3337C15.7018 17.3335 16.0003 17.035 16.0003 16.6668C16.0003 15.5623 15.1049 14.6668 14.0003 14.6668H10.0003ZM6.66699 16.6668C6.66699 14.8259 8.15938 13.3335 10.0003 13.3335H14.0003C15.8413 13.3335 17.3337 14.8259 17.3337 16.6668C17.3337 17.7714 16.4382 18.6668 15.3337 18.6668H8.66699C7.56242 18.6668 6.66699 17.7714 6.66699 16.6668Z"
                          fill="var(--primary-button)"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M12.0003 6.66683C10.8958 6.66683 10.0003 7.56226 10.0003 8.66683C10.0003 9.7714 10.8958 10.6668 12.0003 10.6668C13.1049 10.6668 14.0003 9.7714 14.0003 8.66683C14.0003 7.56226 13.1049 6.66683 12.0003 6.66683ZM8.66699 8.66683C8.66699 6.82588 10.1594 5.3335 12.0003 5.3335C13.8413 5.3335 15.3337 6.82588 15.3337 8.66683C15.3337 10.5078 13.8413 12.0002 12.0003 12.0002C10.1594 12.0002 8.66699 10.5078 8.66699 8.66683Z"
                          fill="var(--primary-button)"
                        />
                      </svg>
                      <SecondaryTitleText>About</SecondaryTitleText>
                    </div>
                    <BodyText style={{ marginRight: '2px' }}>
                      {summary}
                    </BodyText>
                  </div>
                </SecondaryContainer>
              </ContainerWithBorder>
            )}
            {specializations && (
              <ContainerWithBorder>
                <SecondaryContainer>
                  <div className="flex flex-col">
                    <div className="flex flex-row items-center">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle
                          cx="12"
                          cy="12"
                          r="12"
                          fill="#FFB7F5"
                          fill-opacity="0.2"
                        />
                        <path
                          d="M18.9443 14.6662V11.9995H19.1666V14.6662H18.9443Z"
                          fill="white"
                          stroke="#F598B6"
                        />
                        <path
                          d="M12.3332 15.055C12.6672 15.055 12.9927 14.9848 13.2988 14.8451C13.299 14.845 13.2992 14.8449 13.2994 14.8448L16.7221 13.2897V15.7773C16.7221 16.2789 16.3421 16.7616 15.4848 17.1448C14.6482 17.5187 13.5002 17.7217 12.3332 17.7217C11.1662 17.7217 10.0182 17.5187 9.18163 17.1448C8.32434 16.7616 7.94434 16.2789 7.94434 15.7773V13.2892L11.3682 14.8457C11.3683 14.8457 11.3683 14.8457 11.3684 14.8457C11.3684 14.8458 11.3685 14.8458 11.3685 14.8458C11.6739 14.9848 11.9993 15.055 12.3332 15.055Z"
                          stroke="#F598B6"
                        />
                        <path
                          d="M19.1017 9.56528L19.1019 9.56541C19.1414 9.58332 19.1667 9.62218 19.1667 9.66621C19.1667 9.71024 19.1414 9.7491 19.1019 9.767L19.1017 9.76714L12.3794 12.8227L12.5863 13.2779L12.3794 12.8227C12.364 12.8297 12.3484 12.8329 12.3333 12.8329C12.3183 12.8329 12.3027 12.8297 12.2872 12.8227L12.0803 13.2779L12.2872 12.8227L5.56501 9.76714L5.56472 9.767C5.52526 9.7491 5.5 9.71024 5.5 9.66621C5.5 9.62239 5.52501 9.58366 5.56486 9.56563L5.56562 9.56528L12.2871 6.51008C12.2871 6.51004 12.2872 6.51 12.2873 6.50997C12.3169 6.49668 12.3504 6.49668 12.38 6.50997C12.38 6.51001 12.3801 6.51004 12.3802 6.51008L19.1017 9.56528Z"
                          stroke="#F598B6"
                        />
                      </svg>
                      <SecondaryTitleText>Specialization</SecondaryTitleText>
                    </div>
                    <QualificationBodyText>
                      {specializations}
                    </QualificationBodyText>
                  </div>
                </SecondaryContainer>
              </ContainerWithBorder>
            )}
          </div>
          {footer && bookingLabelText.trim() !== '' && (
            <FooterButton
              onClick={bookDoctorFunc}
              buttonText={bookingLabelText}
            ></FooterButton>
          )}
        </>
      )}

      {patientModal && (
        <PatientModal
          hideModal={() => setPatientModal(false)}
          serviceLine={SERVICE_LINE_NAMES.TELE}
          selectPatient={selectRelative}
          selectedPatient={selectedRelative}
          disclaimersAndCheckboxes={disclaimersAndCheckboxes}
          disclaimerMessage={disclaimerMessage}
          selectedVertical={doctorProfile.verticalId}
          getPatient={
            clientConfig.useDopeRelatives
              ? () => getAllDopeRelatives(authToken, doctorProfile.verticalId)
              : undefined
          }
        />
      )}

      {showCalendar && (
        <CalendarModal
          hideModal={() => {
            setShowCalendar(false);
            setSelectedRelative({
              relativeId: -1,
              relativeRelation: null,
              relativeIcon: null,
            });
          }}
          onDateSelection={onDateSelection}
          selectedDate={(date) =>
            setAppointmentDetails((prev) => ({
              ...prev,
              date: date,
            }))
          }
          slots={slots}
        />
      )}
      {showSlots && (
        <Modal>
          <div
            className="modalContainer"
            onClick={(e) => {
              // ignore clicks on the component itself
              e.stopPropagation();
              setShowSlots(false);
            }}
          >
            <FlyInTransition
              in={showSlots}
              mountOnEnter
              unmountOnExit
              onExited={() => setShowSlots(false)}
              appear
            >
              <div
                className="modalBody absolute"
                style={{ minHeight: '500px' }}
              >
                <div className="modalHeader">
                  <div className="flex flex-row items-center">
                    <img src={slotIcon} alt="" />
                    <p className="ml-10px text-body-l text-txtlight-new font-semibold">
                      Choose Appointment Time
                    </p>
                  </div>
                  <CloseContainer
                    onTap={() => {
                      setShowSlots(false);
                      setSelectedRelative({
                        relativeId: -1,
                        relativeRelation: null,
                        relativeIcon: null,
                      });
                    }}
                  >
                    <CloseIcon />
                  </CloseContainer>
                </div>
                <div className=" slots p-4 overflow-auto h-96 pb-16 mx-auto flex flex-col items-center">
                  <SlotsTabs />
                  {SLOTS_TAB.map((t, index) => (
                    <ShowSlotSection
                      key={index}
                      value={t.value}
                      slots={t.slots}
                    />
                  ))}
                </div>
                <div className="w-full flex flex-row justify-center items-center absolute bottom-0 z-10 bg-textbox border border-txtlight-shades4 p-4 pb-6">
                  <PrimaryButton
                    className=" mt-10 w-full"
                    disabled={appointmentDetails.time === ''}
                    onTap={() => {
                      setShowSlots(false);
                      bookDoctorFunc();
                    }}
                  >
                    <div
                      className=" text-body-l text-textbox font-semibold "
                      style={{ textAlign: 'center' }}
                    >
                      Confirm
                    </div>
                  </PrimaryButton>
                </div>
              </div>
            </FlyInTransition>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default DoctorProfileNew;
